import styled from 'styled-components';

import { H2, spacedHeading, H3, nonResponsiveParagraph } from '../../../theme/typography';
import { matchBreakpoint, themeColor, themeSize } from '../../../theme/getters';
import { Content } from '../../../theme/layout';
import { Breakpoints, media } from '../../../theme/media';

import { ExperiencesList } from '../../experience/experiencesList';
import { Button as ButtonComponent } from '../../../shared/components/button';

export const Container = styled(Content)`
  padding: 0;
`;

export const MainWrapper = styled.div`
  max-width: 748px;
  padding: 0 ${themeSize('contentPadding')}px;
  margin: 0 auto 56px;
`;

export const Title = styled(H2)`
  ${spacedHeading};
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : themeSize('contentVerticalMargin'))}px;
`;

export const Thanks = styled(H3)`
  margin-bottom: 56px;
  text-align: center;
  ${media.tablet`
    text-align: left;
  `};
`;

export const SmallInfo = styled.p`
  ${nonResponsiveParagraph};
  color: ${themeColor('gray')};
  text-align: left;
  margin-top: ${themeSize('contentVerticalMargin')}px;
`;

export const AccountContainer = styled.div`
  margin-top: 56px;
`;

export const Info = styled.p`
  ${nonResponsiveParagraph};
  margin-top: 24px;
`;

export const OtherExperiences = styled(ExperiencesList).attrs(props => ({
  rowLayout: !matchBreakpoint(Breakpoints.TABLET)(props),
}))`
  width: 100%;
  padding: 0 ${themeSize('contentPadding')}px;
  margin-bottom: 80px;
`;

export const Button = styled(ButtonComponent)`
  margin: 48px auto 168px;
  max-width: 452px;
`;
